/* eslint-disable prettier/prettier */
const endpoints = {
  get FIBER_API_URL() {
    const parts = getParts();
    // return 'http://192.168.1.111:8081/';
    return `https://${parts.devPrefix}${parts.host}/`;
  },
  get AUTH_API_URL() {
    const parts = getParts();
    return `https://${parts.devPrefix}auth.${parts.host}/`;
  },
  get FIELD_API_URL() {
    const parts = getParts();
    return `https://${parts.devPrefix}${parts.host}/field`;
  },
  get WS_URL() {
    const parts = getParts();
    return `${parts.devPrefix}${parts.host}/ws1/notifications`;
  },
  get IS_BIDDING(){
    return isBidding()
  },
  get FIBER_CLIENT_URL() {
    const parts = getParts();
    let host = parts.host;
    host = host.replace(new RegExp("^bidding.", "gm"), "");
    return `https://${host}/`;
  },
  get BIDDING_CLIENT_URL() {
    const parts = getParts();
    return `https://bidding.${parts.host}/`;
  },
  host_default: null
};

function getParts() {
  let host = getHost();
  let devPrefix = "";
  if (isLocal(host)) {
    if (endpoints.host_default === null) {
      throw "Missing default host configuration";
    }

    host = endpoints.host_default;
  }
  if (isDev(host)) {
    host = host.replace(new RegExp("^dev.", "gm"), "");
    devPrefix = "dev.";
  }

  return { host: host, devPrefix: devPrefix };
}

function getHost() {
  return (new URL(window.location.href)).host;
}

function isDev(host) {
  return false;
  return host.indexOf("dev.") === 0;
}

function isLocal(host) {
  return host.indexOf("localhost") !== -1;
}

function isBidding() {
  let host = getHost();
  if (isLocal(host)) {
    if (endpoints.host_default === null) {
      throw "Missing default host configuration";
    }

    host = endpoints.host_default;
  }

  return host.indexOf('bidding')===0;
}

export default endpoints;



// WEBPACK FOOTER //
// ./src/utils/endpoints.js